import ErrorIcon from '@mui/icons-material/Error';
import InputAdornment from '@mui/material/InputAdornment';
import { SxProps, useTheme } from '@mui/material/styles';
import { MuiTelInput } from 'mui-tel-input';
import type { MuiTelInputInfo } from 'mui-tel-input';
import { Controller, useController, useFormContext } from 'react-hook-form';

type PhoneNumberFormFieldProps = {
  sxOverride?: SxProps;
  labelSxOverride?: SxProps;
  errorColorOverride?: SxProps;
};

function PhoneNumberFormField({
  sxOverride = {},
  labelSxOverride = {},
  errorColorOverride = {}
}: PhoneNumberFormFieldProps) {
  const { control } = useFormContext();
  const {
    field: { onChange: onPhoneChange }
  } = useController({
    name: 'phone'
  });
  const {
    field: { onChange: onPhoneCodeChange }
  } = useController({
    name: 'phoneCode'
  });
  const theme = useTheme();

  return (
    <Controller
      name="fullPhoneNumber"
      control={control}
      render={({ field: { ref, onChange, ...restOfFields }, fieldState }) => (
        <MuiTelInput
          {...restOfFields}
          inputRef={ref}
          onChange={
            // istanbul ignore next
            (value: string, info: MuiTelInputInfo) => {
              const { countryCallingCode, nationalNumber } = info;
              onPhoneCodeChange(countryCallingCode);
              onPhoneChange(nationalNumber);
              onChange(value);
            }
          }
          fullWidth
          required
          forceCallingCode
          defaultCountry="US"
          preferredCountries={['US', 'CA', 'MX']}
          label="Phone Number"
          error={!!fieldState.error?.message}
          helperText={fieldState.error?.message as React.ReactNode}
          sx={theme => ({
            '& .Mui-focused': { color: theme.typography.body1 }
          })}
          InputLabelProps={{
            sx: {
              ...labelSxOverride
            }
          }}
          InputProps={{
            endAdornment:
              // istanbul ignore next
              !!fieldState.error?.message ? (
                <InputAdornment position="end">
                  <ErrorIcon
                    sx={{
                      color: (errorColorOverride as any)?.color || 'error'
                    }}
                  />
                </InputAdornment>
              ) : null,
            sx: { color: theme.typography.body1, ...sxOverride }
          }}
        />
      )}
    />
  );
}

export default PhoneNumberFormField;
